import { useAppSelector } from 'hooks/redux'
import { UserPermission } from 'components/lab/user/permissions'

/**
 * Returns whether the current lab user has the given permission.
 * Non-lab users (e.g. DME, ADMIN) are treated as having the permission
 * so that lab-only permission checks don't affect them.
 *
 * Exception (TES-2881): users with the LAB_USER role are always subject to
 * permission checks, even if their userType isn't 'LAB' (e.g. an admin account
 * switched to the Lab User role) — so assigning the role actually restricts them.
 */
export function useLabPermission(permission: UserPermission): boolean {
  const { userType, permissions, roles } = useAppSelector((state) => state.init)

  const isLabUser = Array.isArray(roles) && roles.includes('LAB_USER')

  if (userType !== 'LAB' && !isLabUser) {
    return true
  }

  return Array.isArray(permissions) && permissions.includes(permission)
}
